<template>
  <div class="site-header-notifications">
    <LLPopper
      v-if="tailwindScreens.sm"
      :show.sync="panelOpened"
      tooltip-white
      :offset="[0, 0]"
      placement="bottom-end"
    >
      <template #trigger>
        <LLButton tertiary-dark>
          <template #icon-left>
            <NotificationIcon />
          </template>
        </LLButton>
        <div v-if="meta.unread" class="site-header-notifications__unread">{{ clamp9(meta.unread) }}</div>
      </template>
      <template #tooltip>
        <NotificationsPanel
          class="site-header-notifications__panel"
          :meta="meta"
          @close="panelOpened = false"
        />
      </template>
    </LLPopper>
    <div v-else>
      <div @click="panelOpened = true">
        <LLButton tertiary-dark>
          <template #icon-left>
            <NotificationIcon />
          </template>
        </LLButton>
      </div>
      <div v-if="meta.unread" class="site-header-notifications__unread">{{ clamp9(meta.unread) }}</div>
      <portal v-if="panelOpened" to="notifications-panel">
        <NotificationsPanel
          class="site-header-notifications__panel_mobile"
          :meta="meta"
          @close="panelOpened = false"
        />
      </portal>
    </div>
  </div>
</template>
<script>
import NotificationIcon from '@/assets/icons/NotificationIcon.vue'
import LLButton from '@/components/common/ui-components/LLButton.vue'
import LLPopper from '@/components/utils/LLPopper.vue'
import NotificationsPanel from '@/components/modules/notifications/notifications-panel.vue'
import Notifications, { notificationEventEnums } from '@/utils/modules/notifications'
import { screenCatcher } from '@/mixins/screenCatcher'
import { setAppBadge } from '@/utils/appBadge'

export default {
  name: 'SiteHeaderNotifications',
  components: { NotificationsPanel, LLPopper, LLButton, NotificationIcon },
  mixins: [screenCatcher],
  data() {
    return {
      panelOpened: false,
      meta: {
        total: undefined,
        unread: undefined
      }
    }
  },
  mounted() {
    this.fetchMeta()
    this.initSocketEvents()
  },
  beforeDestroy() {
    this.destroySocketEvents()
  },
  methods: {
    clamp9(n) {
      if (typeof n !== 'number') return n
      return n > 99 ? '99+' : n
    },
    initSocketEvents() {
      Notifications.addEvent(notificationEventEnums.META, this.onMetaUpdate)
    },
    onMetaUpdate({ meta: { total, unread } = {} } = {}) {
      this.meta.total = total
      this.meta.unread = unread
      // Sync the Home Screen app icon badge whenever the unread count changes
      if (typeof unread === 'number') {
        setAppBadge(unread)
      }
    },
    destroySocketEvents() {
      Notifications.removeEvent(notificationEventEnums.META, this.onMetaUpdate)
    },
    async fetchMeta() {
      this.isPending = true
      const { total, unread } = await this.$api.notifications.getMeta()
      this.meta.total = total
      this.meta.unread = unread
      this.isPending = false
    }
  }
}
</script>

<style scoped lang="scss">
.site-header-notifications {
  @apply relative;
  &__panel {
    max-height: 500px;
    &_mobile {
      @apply bg-white;
      max-height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      height: 100%;
    }
  }
  &__unread {
    @apply absolute right-0 top-0 mr-1 mt-2;
    @apply bg-accent-01 text-white font-bold w-4 h-4 rounded-full flex items-center justify-center;
    font-size: 8px;
  }
}
</style>
